import CaseStatistics from "./CaseStatistics";

export default CaseStatistics;
